import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationMap = () => {
  const officeLocation = {
    lat: 59.9139,
    lng: 10.7522,
    address: "Storgata 15, 0155 Oslo, Norway",
    name: "Workfolio Office"
  };

  return (
    <div className="bg-card rounded-2xl shadow-elevation overflow-hidden">
      <div className="p-6 border-b border-border">
        <div className="flex items-center space-x-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <Icon name="MapPin" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">
              Our Location
            </h3>
            <p className="text-sm text-muted-foreground">
              Visit us in the heart of Oslo
            </p>
          </div>
        </div>
      </div>
      <div className="relative h-80 bg-muted/30">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title={officeLocation?.name}
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${officeLocation?.lat},${officeLocation?.lng}&z=15&output=embed`}
          className="border-0"
        />
        
        {/* Overlay with address info */}
        <div className="absolute bottom-4 left-4 right-4 bg-card/95 backdrop-blur-sm rounded-lg p-4 shadow-elevation">
          <div className="flex items-start justify-between">
            <div>
              <h4 className="font-medium text-foreground mb-1">
                Workfolio Office
              </h4>
              <p className="text-sm text-muted-foreground">
                {officeLocation?.address}
              </p>
            </div>
            <a
              href={`https://maps.google.com/?q=${officeLocation?.lat},${officeLocation?.lng}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-colors text-sm font-medium"
            >
              <span>Directions</span>
              <Icon name="ExternalLink" size={14} />
            </a>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <div className="font-medium text-foreground mb-1">
              Public Transport
            </div>
            <div className="text-muted-foreground">
              Stortinget Station (2 min walk)
            </div>
          </div>
          <div>
            <div className="font-medium text-foreground mb-1">
              Parking
            </div>
            <div className="text-muted-foreground">
              Street parking available
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationMap;